import { update as update_1, init as init_1 } from "./App/Update.js";

export const init = init_1;

export const update = (msg) => ((model) => update_1(msg, model));

